import { render } from "./vehicle_supply_order.vue?vue&type=template&id=2598148c"
import script from "./vehicle_supply_order.vue?vue&type=script&lang=js"
export * from "./vehicle_supply_order.vue?vue&type=script&lang=js"

import "./vehicle_supply_order.vue?vue&type=style&index=0&id=2598148c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__